import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Footer from "./components/Footer";
import Product from "./pages/Product";
import { useEffect, useState } from "react";
import Header from "./components/Header";
import Academy from "./pages/Academy";
import Company from "./pages/Company";
import Partners from "./pages/Partners";
import Careers from "./pages/Careers";
import Contact from "./components/Contact";
import Federations from "./pages/Federations";
import Tournament from "./pages/Tournament";
import Live from "./pages/Live";
import useScrollToHash from "./hooks/useScrollToHash";
import NotFound from "./pages/NotFound";
// import UnderConstruction from "./pages/UnderConstruction";
import Preloader from './components/Preloader'
import NewsMain from "./pages/NewsPage";
import AdminLogin from "./pages/AdminLogin";
import Talent from "./pages/Talent";
import NewsDetail from "./pages/NewsDetail";
import InsightsDetail from "./pages/InsightsDetail";




const App = () => {
  useScrollToHash();

  // Check localStorage first; if empty, detect browser language
  const getInitialLanguage = () => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) return savedLanguage;

    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.startsWith("ar") ? "ar" : "en";
  };

  const [language, setLanguage] = useState(getInitialLanguage());
  const [loading, setLoading] = useState(true);

  // Set page direction immediately based on detected language
  if (language === "ar") {
    document.documentElement.setAttribute("dir", "rtl");
    document.documentElement.setAttribute("lang", "ar");
  } else {
    document.documentElement.setAttribute("dir", "ltr");
    document.documentElement.setAttribute("lang", "en");
  }

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  // Save preferred language AFTER initial detection or user change
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  

  return (
    <>
      {loading && <Preloader language={language} />}
      {!loading && (
        <>
          <Header language={language} setLanguage={setLanguage} />
          <Routes>
            {/* Pass language to all routes */}
            <Route path="/" element={<Home language={language} />} />
            <Route path="/about" element={<About language={language} />} />
            <Route path="/products" element={<Product language={language} />} />
            <Route path="/products/academy" element={<Academy language={language} />} />
            <Route path="/products/federations" element={<Federations language={language} />} />
            <Route path="/products/tournaments" element={<Tournament language={language} />} />
            <Route path="/products/live" element={<Live language={language} />} />
            <Route path="/company" element={<Company language={language} />} />
            <Route path="/partners" element={<Partners language={language} />} />
            <Route path="/careers" element={<Careers language={language} />} />
            <Route path="careers/talent" element={<Talent language={language} />} />
            <Route path="/news" element={<NewsMain language={language}/>} />
            <Route path="/contact" element={<Contact language={language} />} />
           {/* <Route path="/news/:id" element={<NewsDetail />} /> */}
         <Route path="/news/:language/:id" element={<NewsDetail />} />
         <Route path="/insights/:language/:id" element={<InsightsDetail />} />


            <Route path="*" element={<NotFound />} />
            <Route path="/admin" element={<AdminLogin  language={language}/>} />
            {/* <Route path="/news" element={<UnderConstruction  language={language}/>} />   */}
          </Routes>
          <Footer language={language} />
        </>
      )}
    </>
  );
};

export default App;
